/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
    query DltReadQuery($dltDirectoryId: ID, $displayNameToSearch: String, $take: PositiveInt, $skip: Int) {
      DltRead(dltDirectoryId: $dltDirectoryId, displayNameToSearch: $displayNameToSearch, take: $take, skip: $skip) {
        id,
        createdAt,
        updatedAt,
        displayName,
        senderId,
        content
        status,
        message,
        _totalCount
    }
  }
`
